import axios from "axios";
import store from "@/store";
// import { result } from "lodash";
// import router from "@/router";

function getConfig() {
  let config = {
    baseURL: process.env.VUE_APP_API_DISAVOWL,
    statusCode: 200,
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJnb29nbGVJZCI6IjEwNjY1ODEzNzU1NDI5NTM3NTk5NiJ9.LisypMSKJlqlGXQB530aXjiQ5Ot5UScEfYADeVHVtBs",
      //Authorization: store.state.user.user.token,
    },
  };
  return config;
}

function getAPI(path) {
  console.log(path);
  return axios.get(path, getConfig());
}

function postAPI(path, data) {
  console.log(data);

  return axios.post(path, data, getConfig());
}

function jsonToQueryString(json) {
  let newParamData = Object.keys(json)
    .map(function(key) {
      if (json[key] !== null && json[key] !== undefined) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
      }
    })
    .filter(Boolean)
    .join("&");
  console.log(newParamData);
  return newParamData;
}

export default {
  getLinks(config) {
    if (config.project_id && config.disavow_status) {
      let params = jsonToQueryString(config);
      let filters = store.state.filters.query ? store.state.filters.query : "";
      let id = config.group_id;
      let path =
        process.env.VUE_APP_API_DISAVOWL +
        "/groups/" +
        id +
        "/links/?" +
        params +
        filters;

      return getAPI(path);
    } else {
      return false;
    }
  },
  getGroups(config) {
    if (config.project_id && config.disavow_status) {
      console.log(config);
      let params = jsonToQueryString(config);
      let filters = store.state.groupFilters.query
        ? store.state.groupFilters.query
        : "";
      //let path = "/links/?" + params + filters;

      let path =
        process.env.VUE_APP_API_DISAVOWL + "/groups/" + "/?" + params + filters;
      console.log(path);
      return getAPI(path);
    } else {
      return false;
    }
  },
  getDisavow(project_id) {
    if (project_id) {
      let path = "/files/download/" + project_id;

      return getAPI(path);
    } else {
      return false;
    }
  },
  getCompare(project_id) {
    if (project_id) {
      let path = "/files/compare/" + project_id;
      return getAPI(path);
    } else {
      return false;
    }
  },
  updateLink(data) {
    console.log(data);
    if (data) {
      let path = process.env.VUE_APP_API_DISAVOWL + "/links/" + data.id;
      console.log(path);
      return postAPI(path, data);
    } else {
      return false;
    }
  },
  updateLinks(links) {
    console.log(links);
    if (links.length > 0) {
      let path = process.env.VUE_APP_API_DISAVOWL + "/links";
      return postAPI(path, links);
    } else {
      const notification = {
        type: "error",
        message: "API Service",
        details: "Function <i>updateLinks</i> requires 1 or more links to run.",
      };
      store.dispatch("notification/add", notification, { root: true });
      return false;
    }
  },
  updateDomains(groups) {
    if (groups.length > 0) {
      //let path = process.env.VUE_APP_API_DISAVOWL + "/domains";

      let path = process.env.VUE_APP_API_DISAVOWL + "/groups/bulk";
      console.log(groups);
      return postAPI(path, groups);
    } else {
      const notification = {
        type: "error",
        message: "API Service",
        details: "Function <i>updateLinks</i> requires 1 or more links to run.",
      };
      store.dispatch("notification/add", notification, { root: true });
      return false;
    }
  },
  setDisavowStatus(item, group_id, type, status) {
    if (group_id && type !== undefined && status !== undefined) {
      //let path = process.env.VUE_APP_API_DISAVOWL + "/disavows";

      let groupPath = process.env.VUE_APP_API_DISAVOWL + "/groups";

      //Look at shape for the data that's being passed for the POST function
      // And shape it similiar to the bulk POST

      let newGroup = { ...item };
      console.log(item);

      newGroup.status = status;

      console.log(newGroup);
      /*
			if(store.state.user.user.admin){
				newGroup.updated_by = store.state.user.user.firstName + ' ' + store.state.user.user.lastName;
			}
			*/

      console.log(groupPath);
      //console.log(item);

      item.linksToGroups = true;

      console.log(item);

      let groupChange = postAPI(groupPath, newGroup);

      if (groupChange) return groupChange;
    } else {
      const notification = {
        type: "error",
        message: "API Service:",
        details: "Function <i>disavowLink</i> Missing Parameter(s)",
      };
      store.dispatch("notification/add", notification, { root: true });
      return false;
    }
  },

  updateGroupUser(item, assignee_id) {
    console.log(item, assignee_id);
    if (item && assignee_id !== undefined) {
      let groupPath = process.env.VUE_APP_API_DISAVOWL + "/groups";

      let newGroup = Object.assign({}, item);
      console.log(newGroup);
      delete newGroup.num_links;
      delete newGroup.color;
      newGroup.assignee_id = assignee_id;

      let groupChange = postAPI(groupPath, newGroup);

      if (groupChange) return groupChange;
    } else {
      const notification = {
        type: "error",
        message: "API Service:",
        details: "Function <i>disavowLink</i> Missing Parameter(s)",
      };
      store.dispatch("notification/add", notification, { root: true });
      return false;
    }
  },

  getUploadURL(data) {
    let path = process.env.VUE_APP_API_DISAVOWL + "/file/upload-url";

    path += "/?" + jsonToQueryString(data);
    console.log(path);

    return getAPI(path);
  },
  getWorkerStatus() {
    let path = process.env.VUE_APP_API_DISAVOWL + "/worker/status";

    return getAPI(path);
  },
  getDownloadFile(project_id) {
    let path =
      process.env.VUE_APP_API_DISAVOWL + "/files/download/" + project_id;

    return getAPI(path);
  },

  getUsers(project_id) {
    let path = process.env.VUE_APP_API_DISAVOWL + "/users/bulk";
    if (project_id) {
      path += "/?" + "project_id=" + project_id;
    }

    return getAPI(path);
  },

  updateUsers(data) {
    let path = process.env.VUE_APP_API_DISAVOWL + "/users";

    console.log(data);

    return postAPI(path, data);
  },

  createGroupsFromLinks(data) {
    let path = process.env.VUE_APP_API_DISAVOWL + "/groups";

    console.log(data);

    let theObject = {
      status: "linkstogroups",
    };

    postAPI(path, theObject);
  },
};
